<ion-icon *ngFor="let _ of [].constructor(5)" name="star-outline" [style.color]="rating.defaultColor"></ion-icon>
